import axios from 'axios'
import {
  isLocalDevWithBackend,
  isProduction,
  isStg,
} from 'modules/app-config/environment'
import { STG_ENV } from 'modules/app-config/stg-env'

const epsClient = axios.create({
  baseURL: getUrl(),
  headers: { 'Content-Type': 'application/json' },
  timeout: 5 * 60 * 1000, // 5 minutes
})

epsClient.interceptors.request.use(
  (config) => {
    const { idToken } = JSON.parse(localStorage.getItem('admin-token') || '{}')
    if (idToken) {
      config.headers.Authorization = idToken
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export function getUrl() {
  if (isStg()) {
    return STG_ENV.apiUrl
  }

  if (isProduction()) {
    return 'https://services.sureco.com'
  }

  if (isLocalDevWithBackend()) {
    return 'http://localhost:3010'
  }

  return 'https://api.dev.surecolabs.com'
}

export default epsClient
